module.exports = __webpack_public_path__ + "static/media/barrel4.52212ee3.jpg";